module.exports = __webpack_public_path__ + "img/icon-5.80df5d15.png";